module.exports = __webpack_public_path__ + "img/13-stylists-microlines-popup.png";